angular.module('MyApp')
  .service('ConversaoService', [function () {
    this.Moeda = function(input = 0) {
      input = input == null ? 0 : input;
      return parseFloat(input).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }]);